import { render } from "./opDateTime.vue?vue&type=template&id=2c6c8e64&ts=true"
import script from "./opDateTime.vue?vue&type=script&lang=ts"
export * from "./opDateTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__